import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { forgotPassword, userLogin } from '../controllers/user';
import { Alert } from 'react-bootstrap';
import { useAuth } from '../components/auth/AuthProvider';
import { Link } from 'react-router-dom';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [alert, setAlert] = useState();
  useEffect(() => {
    document.title = 'FAMA - Olvidé Contraseña';
  }, []);
  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const r = await forgotPassword(email);
      setAlert(<Alert variant='success'>{r.message}</Alert>);
    }
    catch (e) {
      setAlert(<Alert variant='danger'>{e.message}</Alert>);
    }
  }

  return (
    <Container>
      <Row className='justify-content-md-center p-4'>
        <Col md={4}>
          <h1>olvidé contraseña</h1>
          {alert}
          <Form className='mt-4 mb-4' onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control type="email" placeholder="Enter email" value={email} onChange={e => setEmail(e.target.value)} />
            </Form.Group>
            <Button variant="primary" type="submit">
              Enviar
            </Button>
          </Form>
          <p><Link to={'/login'}>Iniciar sesión</Link></p>
          <p>¿Aún no tienes cuenta? <Link to={'/registro'}>Crea una cuenta nueva</Link>.</p>
        </Col>
      </Row>
    </Container>
  );
}

export default ForgotPassword;
